import React, { memo, useMemo } from "react";
import { motion } from "framer-motion";

const WavyText = memo(
  ({ text, className = "", delayOffset = 0.02, duration = 0.5 }) => {
    const characters = useMemo(() => [...text], [text]);

    const containerVariants = {
      hidden: {},
      visible: {
        transition: {
          staggerChildren: delayOffset,
        },
      },
    };

    const childVariants = {
      hidden: {
        opacity: 0,
        y: 8,
        filter: "blur(6px)",
      },

      visible: {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",

        transition: {
          duration,
          ease: [0.16, 1, 0.3, 1],
        },
      },
    };

    return (
      <motion.span
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.2,
          margin: "-50px",
        }}
        className={`inline-block will-change-transform ${className}`}
      >
        {characters.map((char, index) => (
          <motion.span
            key={`${char}-${index}`}
            variants={childVariants}
            className="inline-block will-change-transform"
            style={{
              whiteSpace: char === " " ? "pre" : "normal",
              backfaceVisibility: "hidden",
              transform: "translateZ(0)",
            }}
          >
            {char}
          </motion.span>
        ))}
      </motion.span>
    );
  },
);

export default WavyText;
